/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccuracyRouteImport } from './routes/accuracy'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as DiagnosticRouteImport } from './routes/diagnostic'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SpeakingSessionsRouteImport } from './routes/speaking-sessions'
import { Route as TryRouteImport } from './routes/try'
import { Route as VocabularyRouteImport } from './routes/vocabulary'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as AccountBillingRouteImport } from './routes/account.billing'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminHistoryRouteImport } from './routes/admin.history'
import { Route as AdminLessonsRouteImport } from './routes/admin.lessons'
import { Route as AdminLibraryRouteImport } from './routes/admin.library'
import { Route as AdminMyStudentsRouteImport } from './routes/admin.my-students'
import { Route as AdminNotificationsRouteImport } from './routes/admin.notifications'
import { Route as AdminPlansRouteImport } from './routes/admin.plans'
import { Route as AdminSessionsRouteImport } from './routes/admin.sessions'
import { Route as AdminStudentsRouteImport } from './routes/admin.students'
import { Route as AdminSupportRouteImport } from './routes/admin.support'
import { Route as AdminTestsRouteImport } from './routes/admin.tests'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AttemptsAttemptIdRouteImport } from './routes/attempts.$attemptId'
import { Route as LessonsIndexRouteImport } from './routes/lessons.index'
import { Route as LessonsSlugRouteImport } from './routes/lessons.$slug'
import { Route as ProgressSkillRouteImport } from './routes/progress.$skill'
import { Route as AdminBankIndexRouteImport } from './routes/admin.bank.index'
import { Route as AdminBankStimulusIdRouteImport } from './routes/admin.bank.$stimulusId'
import { Route as AdminBankBlueprintsRouteImport } from './routes/admin.bank.blueprints'
import { Route as AdminBankImportRouteImport } from './routes/admin.bank.import'
import { Route as AdminBankNewRouteImport } from './routes/admin.bank.new'
import { Route as AdminContentIndexRouteImport } from './routes/admin.content.index'
import { Route as AdminContentGenerationIdRouteImport } from './routes/admin.content.$generationId'
import { Route as AdminContentNewRouteImport } from './routes/admin.content.new'
import { Route as AdminFeedbackIndexRouteImport } from './routes/admin.feedback.index'
import { Route as AttemptsAttemptIdResultsRouteImport } from './routes/attempts.$attemptId.results'
import { Route as AdminFeedbackAttemptIdItemVersionIdRouteImport } from './routes/admin.feedback.$attemptId.$itemVersionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccuracyRoute = AccuracyRouteImport.update({
  id: '/accuracy',
  path: '/accuracy',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticRoute = DiagnosticRouteImport.update({
  id: '/diagnostic',
  path: '/diagnostic',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeRoute = PracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressRoute = ProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SpeakingSessionsRoute = SpeakingSessionsRouteImport.update({
  id: '/speaking-sessions',
  path: '/speaking-sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const TryRoute = TryRouteImport.update({
  id: '/try',
  path: '/try',
  getParentRoute: () => rootRouteImport,
} as any)
const VocabularyRoute = VocabularyRouteImport.update({
  id: '/vocabulary',
  path: '/vocabulary',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountBillingRoute = AccountBillingRouteImport.update({
  id: '/account/billing',
  path: '/account/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminHistoryRoute = AdminHistoryRouteImport.update({
  id: '/admin/history',
  path: '/admin/history',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLessonsRoute = AdminLessonsRouteImport.update({
  id: '/admin/lessons',
  path: '/admin/lessons',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLibraryRoute = AdminLibraryRouteImport.update({
  id: '/admin/library',
  path: '/admin/library',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMyStudentsRoute = AdminMyStudentsRouteImport.update({
  id: '/admin/my-students',
  path: '/admin/my-students',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
  id: '/admin/notifications',
  path: '/admin/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/admin/plans',
  path: '/admin/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSessionsRoute = AdminSessionsRouteImport.update({
  id: '/admin/sessions',
  path: '/admin/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStudentsRoute = AdminStudentsRouteImport.update({
  id: '/admin/students',
  path: '/admin/students',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSupportRoute = AdminSupportRouteImport.update({
  id: '/admin/support',
  path: '/admin/support',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTestsRoute = AdminTestsRouteImport.update({
  id: '/admin/tests',
  path: '/admin/tests',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AttemptsAttemptIdRoute = AttemptsAttemptIdRouteImport.update({
  id: '/attempts/$attemptId',
  path: '/attempts/$attemptId',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonsIndexRoute = LessonsIndexRouteImport.update({
  id: '/lessons/',
  path: '/lessons/',
  getParentRoute: () => rootRouteImport,
} as any)
const LessonsSlugRoute = LessonsSlugRouteImport.update({
  id: '/lessons/$slug',
  path: '/lessons/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressSkillRoute = ProgressSkillRouteImport.update({
  id: '/$skill',
  path: '/$skill',
  getParentRoute: () => ProgressRoute,
} as any)
const AdminBankIndexRoute = AdminBankIndexRouteImport.update({
  id: '/admin/bank/',
  path: '/admin/bank/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBankStimulusIdRoute = AdminBankStimulusIdRouteImport.update({
  id: '/admin/bank/$stimulusId',
  path: '/admin/bank/$stimulusId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBankBlueprintsRoute = AdminBankBlueprintsRouteImport.update({
  id: '/admin/bank/blueprints',
  path: '/admin/bank/blueprints',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBankImportRoute = AdminBankImportRouteImport.update({
  id: '/admin/bank/import',
  path: '/admin/bank/import',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBankNewRoute = AdminBankNewRouteImport.update({
  id: '/admin/bank/new',
  path: '/admin/bank/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContentIndexRoute = AdminContentIndexRouteImport.update({
  id: '/admin/content/',
  path: '/admin/content/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContentGenerationIdRoute =
  AdminContentGenerationIdRouteImport.update({
    id: '/admin/content/$generationId',
    path: '/admin/content/$generationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminContentNewRoute = AdminContentNewRouteImport.update({
  id: '/admin/content/new',
  path: '/admin/content/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeedbackIndexRoute = AdminFeedbackIndexRouteImport.update({
  id: '/admin/feedback/',
  path: '/admin/feedback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AttemptsAttemptIdResultsRoute =
  AttemptsAttemptIdResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => AttemptsAttemptIdRoute,
  } as any)
const AdminFeedbackAttemptIdItemVersionIdRoute =
  AdminFeedbackAttemptIdItemVersionIdRouteImport.update({
    id: '/admin/feedback/$attemptId/$itemVersionId',
    path: '/admin/feedback/$attemptId/$itemVersionId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accuracy': typeof AccuracyRoute
  '/dashboard': typeof DashboardRoute
  '/design-system': typeof DesignSystemRoute
  '/diagnostic': typeof DiagnosticRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/history': typeof HistoryRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/practice': typeof PracticeRoute
  '/pricing': typeof PricingRoute
  '/progress': typeof ProgressRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/speaking-sessions': typeof SpeakingSessionsRoute
  '/try': typeof TryRoute
  '/vocabulary': typeof VocabularyRoute
  '/account/billing': typeof AccountBillingRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/history': typeof AdminHistoryRoute
  '/admin/lessons': typeof AdminLessonsRoute
  '/admin/library': typeof AdminLibraryRoute
  '/admin/my-students': typeof AdminMyStudentsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/sessions': typeof AdminSessionsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/tests': typeof AdminTestsRoute
  '/admin/users': typeof AdminUsersRoute
  '/attempts/$attemptId': typeof AttemptsAttemptIdRouteWithChildren
  '/lessons/$slug': typeof LessonsSlugRoute
  '/progress/$skill': typeof ProgressSkillRoute
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/lessons/': typeof LessonsIndexRoute
  '/admin/bank/$stimulusId': typeof AdminBankStimulusIdRoute
  '/admin/bank/blueprints': typeof AdminBankBlueprintsRoute
  '/admin/bank/import': typeof AdminBankImportRoute
  '/admin/bank/new': typeof AdminBankNewRoute
  '/admin/content/$generationId': typeof AdminContentGenerationIdRoute
  '/admin/content/new': typeof AdminContentNewRoute
  '/attempts/$attemptId/results': typeof AttemptsAttemptIdResultsRoute
  '/admin/bank/': typeof AdminBankIndexRoute
  '/admin/content/': typeof AdminContentIndexRoute
  '/admin/feedback/': typeof AdminFeedbackIndexRoute
  '/admin/feedback/$attemptId/$itemVersionId': typeof AdminFeedbackAttemptIdItemVersionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accuracy': typeof AccuracyRoute
  '/dashboard': typeof DashboardRoute
  '/design-system': typeof DesignSystemRoute
  '/diagnostic': typeof DiagnosticRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/history': typeof HistoryRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/practice': typeof PracticeRoute
  '/pricing': typeof PricingRoute
  '/progress': typeof ProgressRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/speaking-sessions': typeof SpeakingSessionsRoute
  '/try': typeof TryRoute
  '/vocabulary': typeof VocabularyRoute
  '/account/billing': typeof AccountBillingRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/history': typeof AdminHistoryRoute
  '/admin/lessons': typeof AdminLessonsRoute
  '/admin/library': typeof AdminLibraryRoute
  '/admin/my-students': typeof AdminMyStudentsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/sessions': typeof AdminSessionsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/tests': typeof AdminTestsRoute
  '/admin/users': typeof AdminUsersRoute
  '/attempts/$attemptId': typeof AttemptsAttemptIdRouteWithChildren
  '/lessons/$slug': typeof LessonsSlugRoute
  '/progress/$skill': typeof ProgressSkillRoute
  '/account': typeof AccountIndexRoute
  '/admin': typeof AdminIndexRoute
  '/lessons': typeof LessonsIndexRoute
  '/admin/bank/$stimulusId': typeof AdminBankStimulusIdRoute
  '/admin/bank/blueprints': typeof AdminBankBlueprintsRoute
  '/admin/bank/import': typeof AdminBankImportRoute
  '/admin/bank/new': typeof AdminBankNewRoute
  '/admin/content/$generationId': typeof AdminContentGenerationIdRoute
  '/admin/content/new': typeof AdminContentNewRoute
  '/attempts/$attemptId/results': typeof AttemptsAttemptIdResultsRoute
  '/admin/bank': typeof AdminBankIndexRoute
  '/admin/content': typeof AdminContentIndexRoute
  '/admin/feedback': typeof AdminFeedbackIndexRoute
  '/admin/feedback/$attemptId/$itemVersionId': typeof AdminFeedbackAttemptIdItemVersionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accuracy': typeof AccuracyRoute
  '/dashboard': typeof DashboardRoute
  '/design-system': typeof DesignSystemRoute
  '/diagnostic': typeof DiagnosticRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/history': typeof HistoryRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/practice': typeof PracticeRoute
  '/pricing': typeof PricingRoute
  '/progress': typeof ProgressRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/speaking-sessions': typeof SpeakingSessionsRoute
  '/try': typeof TryRoute
  '/vocabulary': typeof VocabularyRoute
  '/account/billing': typeof AccountBillingRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/history': typeof AdminHistoryRoute
  '/admin/lessons': typeof AdminLessonsRoute
  '/admin/library': typeof AdminLibraryRoute
  '/admin/my-students': typeof AdminMyStudentsRoute
  '/admin/notifications': typeof AdminNotificationsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/sessions': typeof AdminSessionsRoute
  '/admin/students': typeof AdminStudentsRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/tests': typeof AdminTestsRoute
  '/admin/users': typeof AdminUsersRoute
  '/attempts/$attemptId': typeof AttemptsAttemptIdRouteWithChildren
  '/lessons/$slug': typeof LessonsSlugRoute
  '/progress/$skill': typeof ProgressSkillRoute
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/lessons/': typeof LessonsIndexRoute
  '/admin/bank/$stimulusId': typeof AdminBankStimulusIdRoute
  '/admin/bank/blueprints': typeof AdminBankBlueprintsRoute
  '/admin/bank/import': typeof AdminBankImportRoute
  '/admin/bank/new': typeof AdminBankNewRoute
  '/admin/content/$generationId': typeof AdminContentGenerationIdRoute
  '/admin/content/new': typeof AdminContentNewRoute
  '/attempts/$attemptId/results': typeof AttemptsAttemptIdResultsRoute
  '/admin/bank/': typeof AdminBankIndexRoute
  '/admin/content/': typeof AdminContentIndexRoute
  '/admin/feedback/': typeof AdminFeedbackIndexRoute
  '/admin/feedback/$attemptId/$itemVersionId': typeof AdminFeedbackAttemptIdItemVersionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accuracy'
    | '/dashboard'
    | '/design-system'
    | '/diagnostic'
    | '/forgot-password'
    | '/history'
    | '/notifications'
    | '/onboarding'
    | '/practice'
    | '/pricing'
    | '/progress'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/speaking-sessions'
    | '/try'
    | '/vocabulary'
    | '/account/billing'
    | '/admin/analytics'
    | '/admin/history'
    | '/admin/lessons'
    | '/admin/library'
    | '/admin/my-students'
    | '/admin/notifications'
    | '/admin/plans'
    | '/admin/sessions'
    | '/admin/students'
    | '/admin/support'
    | '/admin/tests'
    | '/admin/users'
    | '/attempts/$attemptId'
    | '/lessons/$slug'
    | '/progress/$skill'
    | '/account/'
    | '/admin/'
    | '/lessons/'
    | '/admin/bank/$stimulusId'
    | '/admin/bank/blueprints'
    | '/admin/bank/import'
    | '/admin/bank/new'
    | '/admin/content/$generationId'
    | '/admin/content/new'
    | '/attempts/$attemptId/results'
    | '/admin/bank/'
    | '/admin/content/'
    | '/admin/feedback/'
    | '/admin/feedback/$attemptId/$itemVersionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accuracy'
    | '/dashboard'
    | '/design-system'
    | '/diagnostic'
    | '/forgot-password'
    | '/history'
    | '/notifications'
    | '/onboarding'
    | '/practice'
    | '/pricing'
    | '/progress'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/speaking-sessions'
    | '/try'
    | '/vocabulary'
    | '/account/billing'
    | '/admin/analytics'
    | '/admin/history'
    | '/admin/lessons'
    | '/admin/library'
    | '/admin/my-students'
    | '/admin/notifications'
    | '/admin/plans'
    | '/admin/sessions'
    | '/admin/students'
    | '/admin/support'
    | '/admin/tests'
    | '/admin/users'
    | '/attempts/$attemptId'
    | '/lessons/$slug'
    | '/progress/$skill'
    | '/account'
    | '/admin'
    | '/lessons'
    | '/admin/bank/$stimulusId'
    | '/admin/bank/blueprints'
    | '/admin/bank/import'
    | '/admin/bank/new'
    | '/admin/content/$generationId'
    | '/admin/content/new'
    | '/attempts/$attemptId/results'
    | '/admin/bank'
    | '/admin/content'
    | '/admin/feedback'
    | '/admin/feedback/$attemptId/$itemVersionId'
  id:
    | '__root__'
    | '/'
    | '/accuracy'
    | '/dashboard'
    | '/design-system'
    | '/diagnostic'
    | '/forgot-password'
    | '/history'
    | '/notifications'
    | '/onboarding'
    | '/practice'
    | '/pricing'
    | '/progress'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/speaking-sessions'
    | '/try'
    | '/vocabulary'
    | '/account/billing'
    | '/admin/analytics'
    | '/admin/history'
    | '/admin/lessons'
    | '/admin/library'
    | '/admin/my-students'
    | '/admin/notifications'
    | '/admin/plans'
    | '/admin/sessions'
    | '/admin/students'
    | '/admin/support'
    | '/admin/tests'
    | '/admin/users'
    | '/attempts/$attemptId'
    | '/lessons/$slug'
    | '/progress/$skill'
    | '/account/'
    | '/admin/'
    | '/lessons/'
    | '/admin/bank/$stimulusId'
    | '/admin/bank/blueprints'
    | '/admin/bank/import'
    | '/admin/bank/new'
    | '/admin/content/$generationId'
    | '/admin/content/new'
    | '/attempts/$attemptId/results'
    | '/admin/bank/'
    | '/admin/content/'
    | '/admin/feedback/'
    | '/admin/feedback/$attemptId/$itemVersionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccuracyRoute: typeof AccuracyRoute
  DashboardRoute: typeof DashboardRoute
  DesignSystemRoute: typeof DesignSystemRoute
  DiagnosticRoute: typeof DiagnosticRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HistoryRoute: typeof HistoryRoute
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  PracticeRoute: typeof PracticeRoute
  PricingRoute: typeof PricingRoute
  ProgressRoute: typeof ProgressRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  SpeakingSessionsRoute: typeof SpeakingSessionsRoute
  TryRoute: typeof TryRoute
  VocabularyRoute: typeof VocabularyRoute
  AccountBillingRoute: typeof AccountBillingRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminHistoryRoute: typeof AdminHistoryRoute
  AdminLessonsRoute: typeof AdminLessonsRoute
  AdminLibraryRoute: typeof AdminLibraryRoute
  AdminMyStudentsRoute: typeof AdminMyStudentsRoute
  AdminNotificationsRoute: typeof AdminNotificationsRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminSessionsRoute: typeof AdminSessionsRoute
  AdminStudentsRoute: typeof AdminStudentsRoute
  AdminSupportRoute: typeof AdminSupportRoute
  AdminTestsRoute: typeof AdminTestsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AttemptsAttemptIdRoute: typeof AttemptsAttemptIdRouteWithChildren
  LessonsSlugRoute: typeof LessonsSlugRoute
  AccountIndexRoute: typeof AccountIndexRoute
  AdminIndexRoute: typeof AdminIndexRoute
  LessonsIndexRoute: typeof LessonsIndexRoute
  AdminBankStimulusIdRoute: typeof AdminBankStimulusIdRoute
  AdminBankBlueprintsRoute: typeof AdminBankBlueprintsRoute
  AdminBankImportRoute: typeof AdminBankImportRoute
  AdminBankNewRoute: typeof AdminBankNewRoute
  AdminContentGenerationIdRoute: typeof AdminContentGenerationIdRoute
  AdminContentNewRoute: typeof AdminContentNewRoute
  AdminBankIndexRoute: typeof AdminBankIndexRoute
  AdminContentIndexRoute: typeof AdminContentIndexRoute
  AdminFeedbackIndexRoute: typeof AdminFeedbackIndexRoute
  AdminFeedbackAttemptIdItemVersionIdRoute: typeof AdminFeedbackAttemptIdItemVersionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accuracy': {
      id: '/accuracy'
      path: '/accuracy'
      fullPath: '/accuracy'
      preLoaderRoute: typeof AccuracyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostic': {
      id: '/diagnostic'
      path: '/diagnostic'
      fullPath: '/diagnostic'
      preLoaderRoute: typeof DiagnosticRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice': {
      id: '/practice'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof PracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progress': {
      id: '/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof ProgressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/speaking-sessions': {
      id: '/speaking-sessions'
      path: '/speaking-sessions'
      fullPath: '/speaking-sessions'
      preLoaderRoute: typeof SpeakingSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/try': {
      id: '/try'
      path: '/try'
      fullPath: '/try'
      preLoaderRoute: typeof TryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vocabulary': {
      id: '/vocabulary'
      path: '/vocabulary'
      fullPath: '/vocabulary'
      preLoaderRoute: typeof VocabularyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/billing': {
      id: '/account/billing'
      path: '/account/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AccountBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/history': {
      id: '/admin/history'
      path: '/admin/history'
      fullPath: '/admin/history'
      preLoaderRoute: typeof AdminHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/lessons': {
      id: '/admin/lessons'
      path: '/admin/lessons'
      fullPath: '/admin/lessons'
      preLoaderRoute: typeof AdminLessonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/library': {
      id: '/admin/library'
      path: '/admin/library'
      fullPath: '/admin/library'
      preLoaderRoute: typeof AdminLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/my-students': {
      id: '/admin/my-students'
      path: '/admin/my-students'
      fullPath: '/admin/my-students'
      preLoaderRoute: typeof AdminMyStudentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/notifications': {
      id: '/admin/notifications'
      path: '/admin/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/admin/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sessions': {
      id: '/admin/sessions'
      path: '/admin/sessions'
      fullPath: '/admin/sessions'
      preLoaderRoute: typeof AdminSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/students': {
      id: '/admin/students'
      path: '/admin/students'
      fullPath: '/admin/students'
      preLoaderRoute: typeof AdminStudentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/support': {
      id: '/admin/support'
      path: '/admin/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tests': {
      id: '/admin/tests'
      path: '/admin/tests'
      fullPath: '/admin/tests'
      preLoaderRoute: typeof AdminTestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attempts/$attemptId': {
      id: '/attempts/$attemptId'
      path: '/attempts/$attemptId'
      fullPath: '/attempts/$attemptId'
      preLoaderRoute: typeof AttemptsAttemptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessons/': {
      id: '/lessons/'
      path: '/lessons'
      fullPath: '/lessons/'
      preLoaderRoute: typeof LessonsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lessons/$slug': {
      id: '/lessons/$slug'
      path: '/lessons/$slug'
      fullPath: '/lessons/$slug'
      preLoaderRoute: typeof LessonsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progress/$skill': {
      id: '/progress/$skill'
      path: '/$skill'
      fullPath: '/progress/$skill'
      preLoaderRoute: typeof ProgressSkillRouteImport
      parentRoute: typeof ProgressRoute
    }
    '/admin/bank/': {
      id: '/admin/bank/'
      path: '/admin/bank'
      fullPath: '/admin/bank/'
      preLoaderRoute: typeof AdminBankIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/bank/$stimulusId': {
      id: '/admin/bank/$stimulusId'
      path: '/admin/bank/$stimulusId'
      fullPath: '/admin/bank/$stimulusId'
      preLoaderRoute: typeof AdminBankStimulusIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/bank/blueprints': {
      id: '/admin/bank/blueprints'
      path: '/admin/bank/blueprints'
      fullPath: '/admin/bank/blueprints'
      preLoaderRoute: typeof AdminBankBlueprintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/bank/import': {
      id: '/admin/bank/import'
      path: '/admin/bank/import'
      fullPath: '/admin/bank/import'
      preLoaderRoute: typeof AdminBankImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/bank/new': {
      id: '/admin/bank/new'
      path: '/admin/bank/new'
      fullPath: '/admin/bank/new'
      preLoaderRoute: typeof AdminBankNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/content/': {
      id: '/admin/content/'
      path: '/admin/content'
      fullPath: '/admin/content/'
      preLoaderRoute: typeof AdminContentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/content/$generationId': {
      id: '/admin/content/$generationId'
      path: '/admin/content/$generationId'
      fullPath: '/admin/content/$generationId'
      preLoaderRoute: typeof AdminContentGenerationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/content/new': {
      id: '/admin/content/new'
      path: '/admin/content/new'
      fullPath: '/admin/content/new'
      preLoaderRoute: typeof AdminContentNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/feedback/': {
      id: '/admin/feedback/'
      path: '/admin/feedback'
      fullPath: '/admin/feedback/'
      preLoaderRoute: typeof AdminFeedbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attempts/$attemptId/results': {
      id: '/attempts/$attemptId/results'
      path: '/results'
      fullPath: '/attempts/$attemptId/results'
      preLoaderRoute: typeof AttemptsAttemptIdResultsRouteImport
      parentRoute: typeof AttemptsAttemptIdRoute
    }
    '/admin/feedback/$attemptId/$itemVersionId': {
      id: '/admin/feedback/$attemptId/$itemVersionId'
      path: '/admin/feedback/$attemptId/$itemVersionId'
      fullPath: '/admin/feedback/$attemptId/$itemVersionId'
      preLoaderRoute: typeof AdminFeedbackAttemptIdItemVersionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ProgressRouteChildren {
  ProgressSkillRoute: typeof ProgressSkillRoute
}

const ProgressRouteChildren: ProgressRouteChildren = {
  ProgressSkillRoute: ProgressSkillRoute,
}

const ProgressRouteWithChildren = ProgressRoute._addFileChildren(
  ProgressRouteChildren,
)

interface AttemptsAttemptIdRouteChildren {
  AttemptsAttemptIdResultsRoute: typeof AttemptsAttemptIdResultsRoute
}

const AttemptsAttemptIdRouteChildren: AttemptsAttemptIdRouteChildren = {
  AttemptsAttemptIdResultsRoute: AttemptsAttemptIdResultsRoute,
}

const AttemptsAttemptIdRouteWithChildren =
  AttemptsAttemptIdRoute._addFileChildren(AttemptsAttemptIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccuracyRoute: AccuracyRoute,
  DashboardRoute: DashboardRoute,
  DesignSystemRoute: DesignSystemRoute,
  DiagnosticRoute: DiagnosticRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HistoryRoute: HistoryRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  PracticeRoute: PracticeRoute,
  PricingRoute: PricingRoute,
  ProgressRoute: ProgressRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  SpeakingSessionsRoute: SpeakingSessionsRoute,
  TryRoute: TryRoute,
  VocabularyRoute: VocabularyRoute,
  AccountBillingRoute: AccountBillingRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminHistoryRoute: AdminHistoryRoute,
  AdminLessonsRoute: AdminLessonsRoute,
  AdminLibraryRoute: AdminLibraryRoute,
  AdminMyStudentsRoute: AdminMyStudentsRoute,
  AdminNotificationsRoute: AdminNotificationsRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminSessionsRoute: AdminSessionsRoute,
  AdminStudentsRoute: AdminStudentsRoute,
  AdminSupportRoute: AdminSupportRoute,
  AdminTestsRoute: AdminTestsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AttemptsAttemptIdRoute: AttemptsAttemptIdRouteWithChildren,
  LessonsSlugRoute: LessonsSlugRoute,
  AccountIndexRoute: AccountIndexRoute,
  AdminIndexRoute: AdminIndexRoute,
  LessonsIndexRoute: LessonsIndexRoute,
  AdminBankStimulusIdRoute: AdminBankStimulusIdRoute,
  AdminBankBlueprintsRoute: AdminBankBlueprintsRoute,
  AdminBankImportRoute: AdminBankImportRoute,
  AdminBankNewRoute: AdminBankNewRoute,
  AdminContentGenerationIdRoute: AdminContentGenerationIdRoute,
  AdminContentNewRoute: AdminContentNewRoute,
  AdminBankIndexRoute: AdminBankIndexRoute,
  AdminContentIndexRoute: AdminContentIndexRoute,
  AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,
  AdminFeedbackAttemptIdItemVersionIdRoute:
    AdminFeedbackAttemptIdItemVersionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
